import script from "./Analyzing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Analyzing.vue?vue&type=script&setup=true&lang=ts"

import "./Analyzing.vue?vue&type=style&index=0&id=4fb90fa0&lang=scss&scoped=true"

import exportComponent from "/Users/min_zero/Desktop/haii/projects/alzguard-app-web-at/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb90fa0"]])

export default __exports__